export function getSessionKeyEntradaUnica() {
  if (typeof window !== "undefined") {
    return localStorage.getItem("sessionKeyEntradaUnica");
  }
}

export function deleteSessionKeyEntradaUnica(name = "sessionKeyEntradaUnica") {
  if (!name) {
    return;
  }
  if (typeof window !== "undefined") {
    return localStorage.removeItem(name);
  }
}
